
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import { useFactoryList } from "@/hooks/factory";
import toExamine from "../modules/toExamine.vue";
import { examineEnterprise } from "@/service/api";
import { ElMessage } from "element-plus";

export default defineComponent({
  components: {
    toExamine,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const state = reactive({
      keyWord: "",
      delFactoryId: "",
      userId: computed(() => store.state.manageUser.userId),
      name: computed(() => store.state.manageUser.name),
    });
    //获取表格数据
    const factorys = computed(() => store.state.factory.factorys);
    const visibleModal = ref(false);
    const previewImg = ref();
    const srcList: any[] = [""];
    const loading = ref(true);
    // 获取当前页码数
    const page = computed({
      get: () => store.state.factory.factorys.page,
      set: (val) => {
        store.state.factory.factorys.page = val;
      },
    });
    /**
     * 获取厂商列表
     */
    const getFactorys = async () => {
      loading.value = true;
      await useFactoryList(
        store,
        state.keyWord,
        page.value,
        factorys.value.limit
      );
      loading.value = false;
    };
    /**
     * 搜索
     */
    async function handleSearch() {
      page.value = 1;
      await getFactorys();
    }
    //审核
    function openExamineModal(index: number) {
      state.delFactoryId = factorys.value.rows[index].id;
      visibleModal.value = true;
    }
    //审核通过
    async function addSubmit(val: any) {
      const params = {
        id: state.delFactoryId,
        examineState: val.state,
        remark: val.remark,
        examUserid: state.userId,
        examRealname: state.name,
      };
      const result = await examineEnterprise(params);
      if (result && parseInt(result.code) === 1) {
        ElMessage({ message: "审核成功", type: "success" });
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
      getFactorys();
      closeModal();
    }
    //关闭弹窗
    function closeModal() {
      visibleModal.value = false;
    }
    //查看营业执照
    function lookLicense(index: number) {
      if(!factorys.value.rows[index].businessLicense){
        ElMessage({ message: '暂无营业执照，无法查看', type: "error" });
        return;
      }
      srcList[0] = factorys.value.rows[index].businessLicense;
      previewImg.value.showViewer = true;
    }
    function headerStyle() {
      const cellStyle =
        "background: #ffffff;color: #333333;font-weight:700;width: 100%; font-size: 12px";
      return cellStyle;
    }
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      await getFactorys();
    });
    return {
      ...toRefs(state),
      page,
      factorys,
      visibleModal,
      previewImg,
      srcList,
      loading,
      openExamineModal,
      lookLicense,
      getFactorys,
      handleSearch,
      closeModal,
      addSubmit,
      headerStyle,
    };
  },
});
